import Joi from '@hapi/joi'

// Services
import ExtractValidationResult from 'Services/ExtractValidationResult'

const schema = Joi.object({
  dueDate: Joi.string()
    // .label('Due Date')
    // .message({ 'string.empty': `Please don't leave blank` })
    .required(),
  vendor: Joi.string()
    // .label('Vendor/Payee')
    // .message({ 'string.empty': `Please don't leave blank` })
    .required(),
  department: Joi.string()
    // .label('Requesting Department')
    // .message({ 'string.empty': `Please don't leave blank` })
    .required(),
  particulars: Joi.string()
    // .label('Particulars')
    // .message({ 'string.empty': `Please don't leave blank` })
    .required(),
  project: Joi.string()
    // .label('Project')
    // .message({ 'string.empty': `Please don't leave blank` })
    .required(),
  amount: Joi.number()
    // .label('Amount')
    // .message({ 'number.empty': `Amount must be 1 peso above` })
    .min(1)
    .required(),
  releasingCenter: Joi.string()
    // .label('Releasing Center')
    // .message({ 'string.empty': `Please don't leave blank` })
    .required(),
  selectedFile: Joi.string()
    // .label('Selected File')
    // .message({ 'string.empty': `Please don't leave blank` })
    .required(),
}).options({ abortEarly: false })

const validate = data => ExtractValidationResult(schema.validate(data))

export default validate
